import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "convertObjectToMapFormat",
    standalone: false
})
export class ConvertObjectToMapFormatPipe implements PipeTransform {
  /**
   * This pipe simply takes an object and returns a Map<string,string> containing the items in this object
   * @param objectToConvert a generic object
   * @returns Map<string,string>
   */
  transform(objectToConvert: Object): Map<string, string> {
    const mapResult: Map<string, string> = Object.entries(
      objectToConvert
    ).reduce((map: Map<string, string>, [key, value]) => {
      if (value || value === 0) {
        map.set(key, String(value));
      }
      return map;
    }, new Map<string, string>());
    return mapResult;
  }
}
